import React from 'react';
export function Footer() {
  return <footer className="border-t border-steel/40 bg-carbon px-3 py-3 text-center sm:px-6" data-id="element-69" data-mp="32wd2qgad7ltj">
      <p className="text-[0.66rem] font-semibold text-white/85 sm:text-[0.76rem]" data-id="element-70" data-mp="3ggty8ibanj58">
        © 2026 SAFETY INSPECTION PRO™ — All Rights Reserved.
      </p>
      <p className="mx-auto mt-1 max-w-2xl text-[0.62rem] leading-[1.45] text-mist sm:text-[0.72rem]" data-id="element-71" data-mp="36p6b2tlrso9k">
        SAFETY INSPECTION PRO™ is an educational and professional reference resource. It does not
        guarantee regulatory compliance or replace applicable workplace safety regulations, company
        procedures, specialized inspections, required qualifications, professional training,
        manufacturer instructions, engineering evaluation, or qualified professional judgment.
      </p>
      <p className="mt-1 text-[0.62rem] text-mist sm:text-[0.72rem]" data-id="element-72" data-mp="29zgkbzgigqll">
        <a href="#" className="transition-colors duration-150 ease-out hover:text-safety" data-id="element-73" data-mp="2a19qldn7p8t2">
          Terms &amp; Conditions
        </a>{' '}
        •{' '}
        <a href="#" className="transition-colors duration-150 ease-out hover:text-safety" data-id="element-74" data-mp="3lalf9cv8a1sw">
          Privacy Policy
        </a>{' '}
        •{' '}
        <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-safety" data-id="element-75" data-mp="3gcts0w5j33v1">
          Contact
        </a>
      </p>
      <p className="mt-0.5 text-[0.62rem] text-mist sm:text-[0.72rem]" data-id="element-76" data-mp="3q7u23qrbmu0h">
        Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-safety" data-id="element-77" data-mp="81yyongdi663">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}